import { render, staticRenderFns } from "./RedirectURL.vue?vue&type=template&id=1ba7c94c&scoped=true"
import script from "./RedirectURL.vue?vue&type=script&lang=js"
export * from "./RedirectURL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba7c94c",
  null
  
)

export default component.exports